import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router";
import { getSession } from "../../api/auth.api";
import { useAuthStore } from "../../stores/auth.store";

/**
 * Handles the redirect back from Google OAuth.
 * The API already set the session cookie, so we just fetch the session.
 */
export function AuthCallback() {
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [searchParams] = useSearchParams();
  const isNew = searchParams.get("new") === "1";
  const setUser = useAuthStore((s) => s.setUser);

  useEffect(() => {
    let cancelled = false;
    async function fetchSession() {
      try {
        const { user } = await getSession();
        if (!cancelled) {
          setUser(user);
          setStatus("success");
        }
      } catch {
        if (!cancelled) setStatus("error");
      }
    }
    fetchSession();
    return () => { cancelled = true; };
  }, [setUser]);

  if (status === "loading") {
    return (
      <div className="flex flex-col items-center gap-4 py-16">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-gray-900" />
        <p className="text-gray-600">Completing login...</p>
      </div>
    );
  }

  if (status === "success") {
    return <Navigate to={isNew ? "/register" : "/"} replace />;
  }

  return <Navigate to="/login" replace />;
}
